import React from 'react';
import {IconProps} from "../services/IconConstants";

const TickIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--green)'}
             style={style}
             className={className}
             fill={"none"}>
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M12 22.75C6.06294 22.75 1.25 17.9371 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75ZM15.2473 7.93933L10.453 13.1694L8.69156 11.4079L7.27734 12.8222L10.5159 16.0607L16.7216 9.29078L15.2473 7.93933Z"
                  fill="currentColor" />
        </svg>
    )
}

export default TickIcon;